import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MathplanJobsTable } from '../../../components/MathplanJobs/MathplanJobsTable';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const MathplanSubpage: FC = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageAdministration()} title={t('routes.mathplan.title')}>
      <MathplanJobsTable />
    </Page>
  );
};
